import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiUser, FiCheckCircle, FiXCircle, FiClock, FiAward } from 'react-icons/fi';
import { adminAPI } from '../../../services/api';

const TestResultsDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [test, setTest] = useState(null);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, [id]);

    const loadData = async () => {
        try {
            setLoading(true);
            const [testRes, resultsRes] = await Promise.all([
                adminAPI.getStandaloneTest(id),
                adminAPI.getTestResults(id)
            ]);
            setTest(testRes.data);
            setResults(resultsRes.data.results || []);
        } catch (error) {
            console.error('Ошибка загрузки данных:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div style={{ padding: '40px', textAlign: 'center' }}>Загрузка...</div>;
    }

    if (!test) {
        return <div style={{ padding: '40px', textAlign: 'center', color: '#f44336' }}>Тест не найден</div>;
    }

    const avgScore = results.length > 0
        ? (results.reduce((sum, r) => sum + r.percentage, 0) / results.length).toFixed(1)
        : 0;
    const passedCount = results.filter(r => r.passed).length;

    return (
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            {/* Header */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '30px'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <button
                        onClick={() => navigate('/admin/tests')}
                        style={{
                            padding: '10px 16px',
                            background: '#f0f0f0',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            fontSize: '14px'
                        }}
                    >
                        <FiArrowLeft />
                        Назад
                    </button>
                    <h1 style={{ margin: 0, fontSize: '28px', color: '#2c3e50' }}>
                        Результаты теста: {test.title}
                    </h1>
                </div>
            </div>

            {/* Statistics Cards */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '20px',
                marginBottom: '30px'
            }}>
                <div style={{
                    background: 'white',
                    padding: '25px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
                        <FiUser size={24} color="#4a90e2" />
                        <span style={{ fontSize: '14px', color: '#666' }}>Всего прошли</span>
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: '700', color: '#2c3e50' }}>
                        {results.length}
                    </div>
                </div>

                <div style={{
                    background: 'white',
                    padding: '25px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
                        <FiCheckCircle size={24} color="#52c41a" />
                        <span style={{ fontSize: '14px', color: '#666' }}>Прошли успешно</span>
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: '700', color: '#52c41a' }}>
                        {passedCount}
                    </div>
                </div>

                <div style={{
                    background: 'white',
                    padding: '25px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '10px' }}>
                        <FiAward size={24} color="#faad14" />
                        <span style={{ fontSize: '14px', color: '#666' }}>Средний балл</span>
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: '700', color: '#faad14' }}>
                        {avgScore}%
                    </div>
                </div>
            </div>

            {/* Results List */}
            {results.length === 0 ? (
                <div style={{
                    background: 'white',
                    padding: '60px',
                    borderRadius: '12px',
                    textAlign: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}>
                    <p style={{ fontSize: '18px', color: '#999' }}>
                        Пока нет результатов для этого теста
                    </p>
                </div>
            ) : (
                <div style={{ display: 'grid', gap: '15px' }}>
                    {results.map(result => (
                        <div
                            key={result.id}
                            style={{
                                background: 'white',
                                padding: '25px',
                                borderRadius: '12px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FiUser color="#4a90e2" size={18} />
                                            <strong style={{ fontSize: '16px' }}>
                                                {result.first_name} {result.last_name}
                                            </strong>
                                        </div>
                                        <span style={{
                                            padding: '4px 12px',
                                            background: result.passed ? '#f6ffed' : '#fff1f0',
                                            color: result.passed ? '#52c41a' : '#ff4d4f',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}>
                                            {result.passed ? <FiCheckCircle size={14} /> : <FiXCircle size={14} />}
                                            {result.passed ? 'Пройден' : 'Не пройден'}
                                        </span>
                                    </div>

                                    <div style={{ display: 'flex', gap: '20px', fontSize: '14px', color: '#666' }}>
                                        <span>
                                            <strong>Результат:</strong> {result.score} / {result.max_score} 
                                            ({result.percentage}%)
                                        </span>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            <FiClock size={14} />
                                            {result.time_spent ? `${Math.floor(result.time_spent / 60)} мин` : 'Н/Д'}
                                        </span>
                                        <span>
                                            <strong>Дата:</strong> {new Date(result.completed_at).toLocaleString('ru-RU')}
                                        </span>
                                    </div>
                                </div>

                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: '700',
                                    color: result.passed ? '#52c41a' : '#ff4d4f'
                                }}>
                                    {result.percentage}%
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TestResultsDetailPage;
